<template>
  <div class="releaseNotes-view">
    <div v-html="releaseNotes"/>
  </div>
</template>

<script>
import ReleaseNotesService from '@/domain/services/generalPanel/releaseNotes';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      releaseNotes: null,
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  created() {
    this.getReleaseNotes();
  },
  methods: {
    getReleaseNotes() {
      const { language: userLanguage } = this.user;
      ReleaseNotesService.getReleaseNotes(userLanguage).then((releaseNotes) => {
        this.releaseNotes = releaseNotes;
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.releaseNotes-view
  & ::v-deep
    & p:first-child
      padding-top: 2.8rem
    & h1
      padding-top: 2.3rem
      padding-bottom: 1.2rem
      font-size: 1.3rem
    & h2
      font-weight: bold
      padding-bottom: 0.6rem
    & h3
      font-weight: bold
      padding-bottom: 0.6rem
</style>
